// extracted by mini-css-extract-plugin
export default {"wrapperRoot":"ChatRoomHeaderCaseMember_wrapperRoot__Ycloy"};